import React from "react";
const SelectedRowsContext = React.createContext<Array<any>>([]);

export default SelectedRowsContext;
